import { Injectable, inject } from "@angular/core";
import { TranslocoService } from "@jsverse/transloco";
import { writeCachedLanguage } from "../../lang-override";
import { languageToLangCode, resolveEffectiveLanguage } from "../../resolve-effective-language";
import { UserService } from "../../user/user-profile/shared/user.service";
import { ClientConfigService } from "./client-config.service";

// Resolves the user's saved profile language, else the tenant default, else English, and
// applies it via Transloco. Shared by the app bootstrap and the navbar i18n tools' pseudo-locale
// checkbox, so turning pseudo off always lands back on the normal, user-facing language.
@Injectable({
    providedIn: "root",
})
export class EffectiveLanguageService {
    private clientConfigService = inject(ClientConfigService);
    private userService = inject(UserService);
    private translocoService = inject(TranslocoService);

    apply(): void {
        this.userService.getUserInfoBase().subscribe({
            next: (user) => {
                const effectiveLang = resolveEffectiveLanguage(
                    user.language,
                    this.clientConfigService.defaultLanguage
                );
                const langCode = languageToLangCode(effectiveLang);
                this.translocoService.setActiveLang(langCode);
                // Keeps the pre-login cache (lang-override.ts) honest: this is the one
                // authoritative resolution point, so it's the only writer this needs.
                writeCachedLanguage(langCode);
            },
            // Fail open: leave the language already active rather than blocking on this call.
            error: () => {},
        });
    }
}
